import React, { FC, useEffect, useState } from "react";
import {
  LabelCell,
  MainOuterCard,
  DescriptionCell,
  ItemDetailLeftPanel,
  ItemDetailRightPanel,
  CheckoutDetailPreviewSection,
  ItemDetailMainWrapper,
  SubscriptionStylesWrapper,
} from "../../../shared/styles";
import PurchaseLinkPopUp from "../../PurchaseLinkPopUp";
import TickIcon from "../../../../../../images/common/tick-green.svg";
import EditIcon from "../../../../../../images/products/edit-blue.svg";
import CrossIcon from "../../../../../../images/products/cross-red.svg";
import { observer } from "mobx-react";
import { NavigateFunction } from "react-router-dom";
import {
  AuthService,
  CustomLabel,
  EditableField,
  FlexContainer,
  IOption,
  Loader,
  MadisonBlueButton,
  ToastService,
  ToggleSwitch,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import {
  ItemsStore,
  PurchaseLinkStore,
  PurchaseStore,
  RolesAndPermissionStore,
} from "../../../shared/store";
import {  PurchaseLinkService } from "../../../shared/services";
import {
  PurchaseLinkDetailPageModel,
  PurchaseLinkModel,
  SelectedItemModel,
} from "../../../shared/models";
import {
  PurchaseLinkPriceOption,
  PurchaseVariantSelectionType,
  SystemItemTypes,
} from "../../../shared/enums";
import {
  CheckoutIframeDetailPage,
  DashboardTopBar,
  ItemContentArea,
  RelatedPromoCodesGrid,
  SharingSection,
  SplitDropDown,
} from "../../../shared/components";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

type IProps = {
  id: string;
  purchaseLinkStore: PurchaseLinkStore;
  itemStore: ItemsStore;
  navigate: NavigateFunction;
  purchaseStore: PurchaseStore;
  merchantAccountStore: MerchantAccountStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
};

const PurchaseLinkDetailPage: FC<IProps> = ({
  id,
  purchaseLinkStore,
  itemStore,
  navigate,
  purchaseStore,
  merchantAccountStore,
  rolesAndPermissionStore,
}) => {
  // const [activeNavPill, setActiveNavPill] = useState('details');
  const [showLoader, setShowLoader] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);

  useEffect(() => {
    getPurchaseLinkData();

    return () => {
      itemStore?.setBreadCrumbData();
    };
  }, [id]);

  const getPurchaseLinkData = async () => {
    setShowLoader(true);
    const purchaseLinkResponse = await PurchaseLinkService.getPurchaseLink(
      AuthService.authData.accountId,
      id
    ).toPromise();
    if (purchaseLinkResponse?.result) {
      const data = PurchaseLinkModel.deserializeAPIResponse(
        purchaseLinkResponse.result
      );
      purchaseLinkStore.updatePurchaseLink(data);
      const gridResponse = await PurchaseLinkService.getPurchaseLinksGridData(
        AuthService.authData.accountId,
        purchaseLinkStore.purchaseLinkModel.itemId,
        purchaseLinkStore.purchaseLinkModel.itemType,
        1,
        99999,
        "",
        ""
      ).toPromise();
      setShowLoader(false);
      if (gridResponse?.result) {
        purchaseLinkStore.deserializeAPIResponse(
          gridResponse?.result || [],
          gridResponse?.meta
        );
      }
      itemStore?.setBreadCrumbData(
        new SelectedItemModel({
          route: "/app/items",
          title:
            data.itemType === "Donation"
              ? purchaseLinkResponse.result.donation.name
              : purchaseLinkResponse.result.itemDetails?.name,
        })
      );
      purchaseStore.deserializePurchaseLinkToCustomerFacing(
        purchaseLinkResponse.result
      );
    }
  };

  const onClickIcon = () => {
    navigate(
      `/app/items/detail/${purchaseLinkStore.purchaseLinkModel.itemId}/${purchaseLinkStore.purchaseLinkModel.itemType}/${purchaseLinkStore.purchaseLinkModel.itemDetails?.name}`
    );
  };

  const navPills = () => {
    return (
      <FlexContainer className="purchase-link-topbar">
        <div>
          <FlexContainer alignItems="center" spacing={15}>
            <i
              className={`fa fa-light fa-chevron-left clickable`}
              onClick={() => onClickIcon()}
            ></i>
            <CustomLabel color="#2C3E50" fontSize="30px" fontWeight="600">
              Purchase Link
            </CustomLabel>
          </FlexContainer>
        </div>
      </FlexContainer>
    );
  };

  const row = (
    label: string,
    rightColumn: string | React.ReactNode,
    className?: string
  ): React.ReactNode => {
    return (
      <FlexContainer className={`label-description-row ${className}`}>
        <LabelCell>
          <CustomLabel>{label}</CustomLabel>
        </LabelCell>
        <DescriptionCell>{rightColumn}</DescriptionCell>
      </FlexContainer>
    );
  };

  const optionsrow = (label: string, value: boolean) => {
    return (
      <div className="pl-option-block">
        <FlexContainer spacing={5}>
          <img src={value ? TickIcon : CrossIcon} className="yes-no-icon" />
          {label}
        </FlexContainer>
      </div>
    );
  };

  const getVariantsText = (text: keyof typeof PurchaseVariantSelectionType) => {
    switch (text) {
      case PurchaseVariantSelectionType.AllActiveVariants:
        return "All Active Variants";
      case PurchaseVariantSelectionType.SpecificVariants:
        return "Specific Variants";
      case PurchaseVariantSelectionType.AllActiveVariantsWithInventory:
        return "All Active Variants with inventory";
    }
  };

  const getPricesText = (text: keyof typeof PurchaseLinkPriceOption) => {
    switch (text) {
      case PurchaseLinkPriceOption.AllActive:
        return "All Active Prices";
      case PurchaseLinkPriceOption.Specific:
        return "Specific Prices";
    }
  };

  const renderVariantsorPriceRow = (itemType: keyof typeof SystemItemTypes) => {
    switch (itemType) {
      case SystemItemTypes.Product:
        return row(
          "Variants",
          <CustomLabel>
            {" "}
            {getVariantsText(purchaseLinkStore.purchaseLinkModel.variantsType)}
          </CustomLabel>
        );
      case SystemItemTypes.Membership || SystemItemTypes.Service:
        return row(
          "Prices",
          <CustomLabel>
            {getPricesText(purchaseLinkStore.purchaseLinkModel.priceType)}
          </CustomLabel>
        );
    }
  };

  if (!purchaseLinkStore.detailPage)
    return <>{new Loader(true).loaderComponent}</>;
  const { promoCodes } = purchaseLinkStore.detailPage;

  const handleInputChange = (
    field: keyof PurchaseLinkDetailPageModel,
    value: string | boolean
  ) => {
    purchaseLinkStore.updateDetailPage(
      new PurchaseLinkDetailPageModel({
        ...purchaseLinkStore.detailPage,
        [field]: value,
      })
    );
  };

  const onSaveName = async () => {
    const apiModel =
      purchaseLinkStore.purchaseLinkModel.createAPIModelForNameChange(
        purchaseLinkStore.detailPage.name
      );
    const response =
      await PurchaseLinkService.updatePurchaseLink(apiModel).toPromise();
    if (response?.result) {
      getPurchaseLinkData();
    }
    setIsEdit(false);
    handleInputChange("name", "");
  };

  function body() {
    return (
      <>
        <MainOuterCard>
          {navPills()}
          {/* {activeNavPill === 'details' ? ( */}
          <FlexContainer>
            <ItemDetailLeftPanel className="preview-left-panel">
              <CustomLabel className="pl-sub-header">Details</CustomLabel>
              {row(
                "Status",
                <ToggleSwitch
                  on={
                    purchaseLinkStore.purchaseLinkModel.itemDetails?.isActive ||
                    false
                  }
                  onChange={() => {}}
                />,
                "pl-status-label"
              )}
              {row(
                "Name",
                <EditableField
                  value={
                    purchaseLinkStore.detailPage.name === ""
                      ? purchaseLinkStore.purchaseLinkModel.itemDetails?.name ||
                        ""
                      : purchaseLinkStore.detailPage.name
                  }
                  isEdit={isEdit}
                  onEditClick={() => setIsEdit(true)}
                  onSaveClick={() => onSaveName()}
                  onCancelClick={() => {
                    handleInputChange("name", "");
                    setIsEdit(false);
                  }}
                  onChange={(e) => handleInputChange("name", e.target.value)}
                  placeholder="Enter Name"
                />
              )}

              {renderVariantsorPriceRow(
                purchaseLinkStore.purchaseLinkModel.itemType
              )}
              {row(
                "Promotion",
                <CustomLabel>
                  {purchaseLinkStore.purchaseLinkModel.promotionValue ?? "None"}
                </CustomLabel>
              )}
              {row(
                "Merchant",
                <CustomLabel>
                  {
                    purchaseLinkStore.purchaseLinkModel.selectedMerchantAccount
                      .name
                  }
                </CustomLabel>
              )}
              {row(
                "Seller",
                <CustomLabel>
                  {purchaseLinkStore.purchaseLinkModel.selectedSeller.name}
                </CustomLabel>
              )}
              {row("Purchase Link Id", <CustomLabel>{id}</CustomLabel>)}
              {row(
                "Created Date",
                <CustomLabel>
                  {UtilityMethods.formatMMDDYYYY(
                    purchaseLinkStore.purchaseLinkModel.createdDate
                  )}
                </CustomLabel>
              )}
              {row("Created By", <CustomLabel>{""}</CustomLabel>)}
              <FlexContainer fxLayout="column">
                <CustomLabel className="pl-sub-header">Options</CustomLabel>
                <div className="full-width">
                  <FlexContainer alignItems="center">
                    {optionsrow(
                      "Allow Tax",
                      purchaseLinkStore.purchaseLinkModel.itemDetails?.tax ||
                        false
                    )}
                  </FlexContainer>
                  {purchaseLinkStore.purchaseLinkModel.itemType !==
                    "Donation" && (
                    <FlexContainer alignItems="center">
                      {optionsrow(
                        "Customer Chooses Quantity",
                        purchaseLinkStore.purchaseLinkModel.chooseQuantity ||
                          false
                      )}
                      {optionsrow(
                        "Show Original Price",
                        purchaseLinkStore.purchaseLinkModel.showOriginalPrice
                      )}
                    </FlexContainer>
                  )}
                  {purchaseLinkStore.purchaseLinkModel.itemType !==
                    "Donation" && (
                    <FlexContainer alignItems="center">
                      {/* {purchaseLinkStore.purchaseLinkModel.itemType !== 'Product' &&
                                                optionsrow(
                                                    'Allow Discount',
                                                    purchaseLinkStore.purchaseLinkModel.itemDetails?.discount || false,
                                                )} */}
                      {optionsrow(
                        "Allow Returns",
                        purchaseLinkStore.purchaseLinkModel.itemDetails
                          ?.return || false
                      )}
                    </FlexContainer>
                  )}
                  <FlexContainer alignItems="center">
                    {optionsrow(
                      "Include Related Items",
                      purchaseLinkStore.purchaseLinkModel.includeRelatedItems ||
                        false
                    )}
                    {purchaseLinkStore.purchaseLinkModel.itemType !==
                      "Donation" &&
                      purchaseLinkStore.purchaseLinkModel.itemType !==
                        "Product" &&
                      optionsrow(
                        "No Trial",
                        !purchaseLinkStore.purchaseLinkModel.freeTrial || false
                      )}
                  </FlexContainer>
                </div>
              </FlexContainer>
              <SharingSection
                purchaseURL={purchaseLinkStore.purchaseLinkModel.link}
                //handleInputChange={handleInputChange}
                // detailPage={purchaseLinkStore.detailPage}
                name={
                  purchaseLinkStore.purchaseLinkModel.itemDetails?.name ?? ""
                }
                id={id}
              />
            </ItemDetailLeftPanel>

            <ItemDetailRightPanel
              borderLeft="none"
              className="preview-detail-section"
              padding="0px 0px 0px 25px"
            >
              <CustomLabel
                fontWeight={"600"}
                fontSize={"20px"}
                margin="0px 0px 20px 0px"
              >
                Preview
              </CustomLabel>
              <CheckoutDetailPreviewSection>
                <CheckoutIframeDetailPage purchaseStore={purchaseStore} />
              </CheckoutDetailPreviewSection>
            </ItemDetailRightPanel>
          </FlexContainer>
        </MainOuterCard>
        <RelatedPromoCodesGrid promoCodes={promoCodes} countriesWithState={itemStore.countryStore.countriesWithState} />
      </>
    );
  }

  const getCurrentPosition = () => {
    const currentIndex = purchaseLinkStore.gridData.findIndex(
      (payment) => payment.id === id
    );
    return currentIndex !== -1 ? currentIndex + 1 : null;
  };

  const handleNavigation = (direction: "back" | "next") => {
    const newId = direction === "next" ? getNextId() : getPreviousId();
    if (newId) {
      navigate(`/app/purchase-link/detail/${newId}`);
    } else {
      ToastService.showError("No more purchase links in this direction.");
    }
  };

  const getNextId = () => {
    const currentIndex = purchaseLinkStore.gridData.findIndex(
      (payment) => payment.id === id
    );
    if (
      currentIndex !== -1 &&
      currentIndex < purchaseLinkStore.gridData.length - 1
    ) {
      return purchaseLinkStore.gridData[currentIndex + 1].id;
    }
    return null;
  };

  const getPreviousId = () => {
    const currentIndex = purchaseLinkStore.gridData.findIndex(
      (payment) => payment.id === id
    );
    if (currentIndex > 0) {
      return purchaseLinkStore.gridData[currentIndex - 1].id;
    }
    return null;
  };

  const actionDropdown = () => {
    return (
      <SplitDropDown
        label="Edit"
        onClick={() => {
          setShowEditPopup(true);
        }}
        className="edit-dropdown-item"
        options={[
          {
            icon: EditIcon,
            label: "Edit",
            value: "edit",
            onClick: () => {
              setShowEditPopup(true);
            },
          },
        ]}
      />
    );
  };

  const onclosePopUp = (refresh: boolean) => {
    if (refresh) {
      getPurchaseLinkData();
    }
    setShowEditPopup(false);
  };

  const currentPosition = getCurrentPosition();
  return (
    <>
      <DashboardTopBar
        itemStore={itemStore}
        rolesAndPermissionStore={rolesAndPermissionStore}
        subRoute={purchaseLinkStore.purchaseLinkModel.itemDetails?.name}
        merchantAccountStore={merchantAccountStore}
        rightContent={
          <>
            {purchaseLinkStore.gridData.length > 0 && (
              <FlexContainer
                alignItems="center"
                spacing={10}
                justifyContent="flex-end"
                margin="0px 20px 0px"
              >
                <MadisonBlueButton
                  minWidth={""}
                  onClick={() => handleNavigation("back")}
                  disabled={!getPreviousId()}
                  lineHeight="inherit"
                  padding="0px 15px"
                >
                  Back
                </MadisonBlueButton>
                <CustomLabel fontSize={"20px"}>
                  {currentPosition
                    ? `${currentPosition} of ${purchaseLinkStore.gridData.length}`
                    : `0 of ${purchaseLinkStore.gridData.length}`}
                </CustomLabel>
                <MadisonBlueButton
                  minWidth={""}
                  onClick={() => handleNavigation("next")}
                  disabled={!getNextId()}
                  lineHeight="inherit"
                  padding="0px 15px"
                >
                  Next
                </MadisonBlueButton>
              </FlexContainer>
            )}
            {actionDropdown()}
          </>
        }
      />
      <ItemContentArea
        itemStore={itemStore}
        showMerchantAccountNotificationBar={merchantAccountStore.hasNotificationBar()}
        node={
          <ItemDetailMainWrapper>
            <SubscriptionStylesWrapper className="purchase-link-detail-page">
              {body()}
            </SubscriptionStylesWrapper>
          </ItemDetailMainWrapper>
        }
        showLoader={showLoader}
      />
      {showEditPopup && (
        <PurchaseLinkPopUp
          isEdit={true}
          purchaseLinkStore={purchaseLinkStore}
          onClose={(refresh: boolean) => onclosePopUp(refresh)}
        />
      )}
    </>
  );
};

export default withRouter(observer(PurchaseLinkDetailPage));
